import React, {useState} from 'react';
import {useSelector} from "react-redux";
import {StopoverButton, useIsStopoverAvailableConnected} from "../../../../index";
import {t} from 'ttag';
import Box from "@material-ui/core/Box";
import CircularProgress from "@material-ui/core/CircularProgress";
import {BOOK_STOPOVER_FORM_REF} from "../../common/book-form-input-refs";
import {SW_FLIGHT_TYPES, SW_PASSENGER_TYPES} from "../../../../../store/types";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";

const BookStopoverSubmitButtonConnected = () => {

    const [submitting, setSubmitting] = useState(false);
    const isStopoverAvailable = useIsStopoverAvailableConnected();
    const {loading, outbound, inbound} = useSelector(state => state.sw.book.stopover);
    const currentLanguage = useSelector(state => state.app.currentLanguage);
    const isOutboundDefined = Boolean(outbound?.enabled && outbound?.selectedAirport && outbound?.numberOfNights && outbound?.departureDate);
    const isInboundDefined = Boolean(inbound?.enabled && inbound?.selectedAirport && inbound?.numberOfNights && inbound?.departureDate);

    const {
        origin = '',
        destination = '',
        departure = '',
        arrival = '',
        adults = '',
        children = '',
        infants = '',
        flightType = '',
    } = useSelector(state => state.sw.book);

    const isRoundTrip = flightType === SW_FLIGHT_TYPES.RETURN;
    const isOneWay = flightType === SW_FLIGHT_TYPES.ONE_WAY;

    const canSubmit = (() => {
        return Boolean(
            isStopoverAvailable
            && ((isOneWay && isOutboundDefined) || (isRoundTrip && (isOutboundDefined || isInboundDefined)))
        );
    })();

    const form = (() => {
        if (!canSubmit) return null;
        let legIdx = 0;
        return (
            <form method={'POST'}
                  action={`${process.env.REACT_APP_SUBMIT_URL}?lang=${currentLanguage.substring(0, 2)}`}
                  // target={'_blank'}
                  ref={BOOK_STOPOVER_FORM_REF}>
                <input type={'hidden'} name={'action'} value={'flightSearch'}/>
                <input type={'hidden'} name={'flightType'} value={'MULTI'}/>
                <input type={'hidden'} name={'paxType'} value={SW_PASSENGER_TYPES.ADULT}/>
                <input type={'hidden'} name={'numADT'} value={adults}/>
                <input type={'hidden'} name={'numCHD'} value={children}/>
                <input type={'hidden'} name={'numINF'} value={infants}/>
                {/*<input type={'hidden'} name={'carrierCodes'} value={'SP,S4'}/>*/}
                <input type={'hidden'} name={'utm_source'} value={'sataazores_PT'}/>
                <input type={'hidden'} name={'utm_medium'} value={'referral'}/>
                <input type={'hidden'} name={'utm_campaign'} value={'home_page_nav'}/>
                <input key={`origin${legIdx}`} type={'hidden'} name={`origin${legIdx}`} value={origin?.code || ''}/>
                <input key={`destination${legIdx}`} type={'hidden'} name={`destination${legIdx}`} value={isOutboundDefined ? outbound.selectedAirport : (destination?.code || '')}/>
                <input key={`flightDate${legIdx}`} type={'hidden'} name={`flightDate${legIdx}`} value={departure || ''}/>
                {Boolean(isOutboundDefined && ++legIdx) && ([
                    <input key={`origin${legIdx}`} type={'hidden'} name={`origin${legIdx}`} value={outbound.selectedAirport || ''}/>,
                    <input key={`destination${legIdx}`} type={'hidden'} name={`destination${legIdx}`} value={destination?.code || ''}/>,
                    <input key={`flightDate${legIdx}`} type={'hidden'} name={`flightDate${legIdx}`} value={outbound.departureDate || ''}/>
                ])}
                {Boolean(isRoundTrip && ++legIdx) && ([
                    <input key={`origin${legIdx}`} type={'hidden'} name={`origin${legIdx}`} value={destination?.code || ''}/>,
                    <input key={`destination${legIdx}`} type={'hidden'} name={`destination${legIdx}`} value={isInboundDefined ? inbound.selectedAirport : (origin?.code || '')}/>,
                    <input key={`flightDate${legIdx}`} type={'hidden'} name={`flightDate${legIdx}`} value={arrival || ''}/>
                ])}
                {Boolean(isRoundTrip && isInboundDefined && ++legIdx) && ([
                    <input key={`origin${legIdx}`} type={'hidden'} name={`origin${legIdx}`} value={inbound.selectedAirport || ''}/>,
                    <input key={`destination${legIdx}`} type={'hidden'} name={`destination${legIdx}`} value={origin?.code || ''}/>,
                    <input key={`flightDate${legIdx}`} type={'hidden'} name={`flightDate${legIdx}`} value={inbound.departureDate || ''}/>
                ])}
            </form>
        );
    })();

    const submitHandler = () => {
        try {
            setSubmitting(true);
            BOOK_STOPOVER_FORM_REF.current.submit();
        } catch (e) {
            setSubmitting(false);
        }
    }

    return (
        <Box display={'flex'} justifyContent={'center'}>
            {canSubmit && form}
            <StopoverButton
                title={t`Stopover`}
                subtitle={t`with Flight`}
                disabled={Boolean(loading || submitting || !canSubmit)}
                onClick={submitHandler}
                icon={submitting ? <CircularProgress/> : <ArrowForwardIosIcon/>}
            />
        </Box>
    );
};

export default BookStopoverSubmitButtonConnected;
